export default __webpack_public_path__ + "static/media/linked-in-icon.54aa75ff.svg";